import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { TextButton, InfoWidget } from '@ds/react-components';
import { List as ListLoader } from 'react-content-loader';
import {
  RowRightText,
  RowLeftText,
  RowContainer,
} from '../common/InfoRowComponents';

import * as Styled from './EmergencyContactPreview.styled';

const styles = (theme) => ({
  root: {},
  data: {
    height: 40,
  },
  loader: {
    height: 150,
    width: '100%',
  },
});

const EmergencyContactPreview = (props) => {
  const { classes, customerDetails, permissions } = props;
  const { adfitNo, contacts } = customerDetails;
  const anyContact = contacts && contacts[0];
  const emergencyContact =
    anyContact && contacts.find((c) => c.contactType === 'PE');
  const showEmergency = emergencyContact && emergencyContact.contactName;

  return (
    <InfoWidget
      title={'Emergency Contact'}
      actionButton={
        (permissions.includes('IsAdmin') ||
          permissions.includes('CanManageVariations')) && (
          <Link to={`/Customers/${adfitNo}/Variations`}>
            <TextButton>{showEmergency ? 'Edit' : <span>Add</span>}</TextButton>
          </Link>
        )
      }
      isLoading={!adfitNo}
      contentLoader={<ListLoader className={classes.loader} />}
      classes={{ root: classes.root }}>
      {showEmergency && (
        <Styled.Container>
          <RowContainer>
            <RowLeftText>{'Full Name'} </RowLeftText>
            <RowRightText>
              {emergencyContact && emergencyContact.contactName}
            </RowRightText>
          </RowContainer>
          <RowContainer>
            <RowLeftText>{'Contact'} </RowLeftText>
            <RowRightText>
              {emergencyContact && emergencyContact.contactDetail}
            </RowRightText>
          </RowContainer>
        </Styled.Container>
      )}
    </InfoWidget>
  );
};

EmergencyContactPreview.propTypes = {
  classes: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired,
};

export default withStyles(styles)(EmergencyContactPreview);
